import React from 'react'
import { StaticQuery, graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
// import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons'

const Header = () => (
  <StaticQuery
    query={graphql`
      query HeaderQuery {
        background: file(relativePath: { eq: "supernovastock.png" }) {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        logo: file(relativePath: { eq: "supernovalayer.png" }) {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
  >
    {({ background, logo }) => (
      <div className="header">
        <div className="header__image-wrapper">
          <Img
            fluid={background.childImageSharp.fluid}
            style={{
              height: '100%',
              width: '100%',
            }}
            imgStyle={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
          <div className="header__logo">
            <Img
              fluid={logo.childImageSharp.fluid}
              style={{
                height: '100%',
                width: '100%',
              }}
              imgStyle={{
                height: '100%',
                width: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
              }}
            />
          </div>
          {/* <div className="header__overlay" /> */}
        </div>
        <div className="header__content">
          <div className="header__info">
            {/* <FontAwesomeIcon
              fixedWidth
              size="1x"
              className="header__icon"
              icon={faCalendarAlt}
            /> */}
            <p className="header__date">15th of October</p>
            <p className="header__location">Cairo, Egypt</p>
            {/* <FontAwesomeIcon
              fixedWidth
              size="1x"
              className="header__icon"
              icon={faMapMarkerAlt}
            /> */}
          </div>
          <Link
            to="/register"
            className="btn btn-outline-light btn-lg header_btn"
          >
            Register Now
          </Link>
          {/* <h1 className="header__heading">Supernova</h1> */}
        </div>
      </div>
    )}
  </StaticQuery>
)

export default Header
